<template>
    <div class="bg-white w-100 rounded-4 d-flex flex-column gap-4 my-4 px-4">
        <!-- App Startup Screen Logo and Background -->
        <div class="d-flex gap-4 rounded-4 border p-5">
            <div class="w-50 d-flex flex-column gap-2">
                <h3 style="font-size: 1.3rem" class="mb-2">App Startup logo (Splash Screen)</h3>
                <input
                    type="file"
                    name="app_startup_logo"
                    id="app_startup_logo"
                    accept=".jpg, .jpeg, .png, .webp"
                    hidden
                    @change="uploadImage"
                    :disabled="disableBtn"
                />
                <label for="app_startup_logo" class="upload-section w-90">
                    <span class="upload-section-title">Choose Startup logo</span>
                    <span
                        v-if="app_startup_logo_loading"
                        class="upload-btn px-5 py-3 d-flex gap-3 px-4"
                        :class="disableBtn ? 'btn-disabled' : ''"
                    >
                        <SpinLoader />Uploading
                    </span>
                    <span
                        v-else
                        class="upload-btn px-5 py-3 d-flex justify-content-center align-items-center gap-2"
                        :class="disableBtn ? 'btn-disabled' : ''"
                    >
                        <img src="@/assets/px/drag-and-drop/upload.svg" alt="" style="height: 25px" />
                        Upload Icon
                    </span>
                </label>
                <span v-if="app_startup_logo_err" class="text-danger">{{ app_startup_logo_err }}</span>
                <span v-if="errors.app_startup_logo" class="text-danger">{{ errors.app_startup_logo }}</span>
                <div class="d-flex justify-content-center align-items-center mt-4 w-90">
                    <div
                        class="d-flex justify-content-center align-items-center"
                        style="width: 15rem; height: 8rem; border: 2px dashed #d7d7d7; border-radius: 15px"
                    >
                        <img
                            v-if="app_startup_logo"
                            :src="app_startup_logo"
                            alt=""
                            style="height: 5rem; border-radius: 15px"
                        />
                        <img v-else src="@/assets/px/drag-and-drop/photo-gallery.svg" alt="" style="height: 5rem" />
                    </div>
                </div>
            </div>

            <div class="w-50 d-flex flex-column gap-2">
                <h3 style="font-size: 1.3rem" class="mb-2">App Startup screen background</h3>
                <input
                    type="file"
                    name="app_startup_screen_background"
                    id="app_startup_screen_background"
                    accept=".jpg, .jpeg, .png, .webp"
                    hidden
                    @change="uploadImage"
                    :disabled="disableBtn"
                />
                <label for="app_startup_screen_background" class="upload-section w-90">
                    <span class="upload-section-title">Choose App Startup screen background</span>
                    <span
                        v-if="app_startup_screen_background_loading"
                        class="upload-btn px-5 py-3 d-flex gap-3 px-4"
                        :class="disableBtn ? 'btn-disabled' : ''"
                    >
                        <SpinLoader />Uploading
                    </span>
                    <span
                        v-else
                        class="upload-btn px-5 py-3 d-flex justify-content-center align-items-center gap-2"
                        :class="disableBtn ? 'btn-disabled' : ''"
                    >
                        <img src="@/assets/px/drag-and-drop/upload.svg" alt="" style="height: 25px" />
                        Upload Icon
                    </span>
                </label>
                <span v-if="app_startup_screen_background_err" class="text-danger">{{
                    app_startup_screen_background_err
                }}</span>
                <span v-if="errors.app_startup_screen_background" class="text-danger">{{
                    errors.app_startup_screen_background
                }}</span>
                <div class="d-flex justify-content-center align-items-center mt-4 w-90">
                    <div
                        class="d-flex justify-content-center align-items-center"
                        style="width: 15rem; height: 8rem; border: 2px dashed #d7d7d7; border-radius: 15px"
                    >
                        <img
                            v-if="app_startup_screen_background"
                            :src="app_startup_screen_background"
                            alt=""
                            style="height: 5rem; border-radius: 15px"
                        />
                        <img v-else src="@/assets/px/drag-and-drop/photo-gallery.svg" alt="" style="height: 5rem" />
                    </div>
                </div>
            </div>

            <div class="w-50 d-flex flex-column gap-2">
                <h3 style="font-size: 1.3rem" class="mb-2">Waiting Animation</h3>
                <input
                    type="file"
                    name="waiting_animation"
                    id="waiting_animation"
                    accept=".gif"
                    hidden
                    @change="uploadImage"
                    :disabled="disableBtn"
                />
                <label for="waiting_animation" class="upload-section w-90">
                    <span class="upload-section-title">Choose Waiting Animation</span>
                    <span
                        v-if="waiting_animation_loading"
                        class="upload-btn px-5 py-3 d-flex gap-3 px-4"
                        :class="disableBtn ? 'btn-disabled' : ''"
                    >
                        <SpinLoader />Uploading
                    </span>
                    <span
                        v-else
                        class="upload-btn px-5 py-3 d-flex justify-content-center align-items-center gap-2"
                        :class="disableBtn ? 'btn-disabled' : ''"
                    >
                        <img src="@/assets/px/drag-and-drop/upload.svg" alt="" style="height: 25px" />
                        Upload Icon
                    </span>
                </label>
                <span v-if="waiting_animation_err" class="text-danger">{{ waiting_animation_err }}</span>
                <span v-if="errors.waiting_animation" class="text-danger">{{ errors.waiting_animation }}</span>
                <div class="d-flex justify-content-center align-items-center mt-4 w-90">
                    <div
                        class="d-flex justify-content-center align-items-center"
                        style="width: 15rem; height: 8rem; border: 2px dashed #d7d7d7; border-radius: 15px"
                    >
                        <img
                            v-if="waiting_animation"
                            :src="waiting_animation"
                            alt=""
                            style="height: 5rem; border-radius: 15px"
                        />
                        <img v-else src="@/assets/px/drag-and-drop/photo-gallery.svg" alt="" style="height: 5rem" />
                    </div>
                </div>
            </div>
        </div>

        <!-- Product Slides -->
        <div class="bg-white w-100 rounded-4 border">
            <h1
                class="px-5 py-3 page-heading d-flex justify-content-between"
                style="background: #f1f7ff; font-weight: bold; border-radius: 14px 14px 0 0"
            >
                Product Intro Slides
                <button
                    v-if="introSlideList.length"
                    type="button"
                    class="text-button btn-save"
                    :class="disableBtn || introSlideList.length >= 10 ? 'btn-disabled' : ''"
                    @click="showIntroSlidesEditModal = true"
                    :disabled="disableBtn || introSlideList.length >= 10"
                >
                    Add Slides
                </button>
            </h1>

            <div
                v-if="!introSlideList.length"
                class="d-flex flex-column justify-content-center align-items-center p-4 gap-2"
                style="min-height: 6rem"
            >
                <button
                    type="button"
                    class="add-btn"
                    :class="disableBtn ? 'btn-disabled' : ''"
                    @click="showIntroSlidesEditModal = true"
                    :disabled="disableBtn"
                >
                    <img src="@/assets/px/drag-and-drop/add.svg" alt="" style="height: 25px" />
                    Add Slides
                </button>
            </div>

            <div v-else class="d-flex flex-column p-4 gap-2">
                <IntroSlideCard
                    v-for="(productSlide, index) in introSlideList"
                    :key="productSlide.id"
                    :profileFunction="{ ...productSlide, index }"
                    :disableActiveIntroSlides="disableActiveIntroSlides"
                    :disableBtn="disableBtn"
                    @handleIntroSlide="handleIntroSlide"
                    @onToggle="introSlideToggle"
                    @handleDelete="handleDeleteIntroSlide"
                />
            </div>
            <span v-if="errors.introSlideList" class="mx-4 text-danger">{{ errors.introSlideList }}</span>
            <span class="mx-4 mt-3 mb-4 font-16 weight-600 text-secondary d-block">
                Note: You can add up to 10 slides. Exactly 3 slides must remain active at all times.
            </span>
        </div>

        <!-- Sign up/ Login Content -->
        <div class="bg-white w-100 rounded-4 border">
            <h1
                class="px-5 py-3 page-heading d-flex justify-content-between"
                style="background: #f1f7ff; font-weight: bold; border-radius: 14px 14px 0 0"
            >
                Sign up/Login Content
            </h1>
            <div class="d-flex flex-column justify-content-center p-4">
                <div class="d-flex gap-4">
                    <div class="w-60 d-flex flex-column gap-2">
                        <h3 style="font-size: 1.3rem" class="mb-2">Sign up/Login logo</h3>
                        <input
                            type="file"
                            name="signup_logo"
                            id="signup_logo"
                            accept=".jpg, .jpeg, .png, .webp"
                            hidden
                            @change="uploadImage"
                            :disabled="disableBtn"
                        />
                        <label for="signup_logo" class="upload-section w-90">
                            <span class="upload-section-title">Upload Sign up/Login logo</span>
                            <span
                                v-if="signup_logo_loading"
                                class="upload-btn px-5 py-3 d-flex gap-3 px-4"
                                :class="disableBtn ? 'btn-disabled' : ''"
                            >
                                <SpinLoader />Uploading
                            </span>
                            <span
                                v-else
                                class="upload-btn px-5 py-3 d-flex justify-content-center align-items-center gap-2"
                                :class="disableBtn ? 'btn-disabled' : ''"
                            >
                                <img src="@/assets/px/drag-and-drop/upload.svg" alt="" style="height: 25px" />
                                Upload Icon
                            </span>
                        </label>
                        <span v-if="signup_logo_err" class="text-danger">{{ signup_logo_err }}</span>
                        <span v-if="errors.signup_logo" class="text-danger">{{ errors.signup_logo }}</span>
                    </div>
                    <div class="w-40 d-flex justify-content-center align-items-center mt-4">
                        <div
                            class="d-flex justify-content-center align-items-center"
                            style="width: 15rem; height: 8rem; border: 2px dashed #d7d7d7; border-radius: 15px"
                        >
                            <img
                                v-if="signup_logo"
                                :src="signup_logo"
                                alt=""
                                style="height: 5rem; border-radius: 15px"
                            />
                            <img v-else src="@/assets/px/drag-and-drop/photo-gallery.svg" alt="" style="height: 5rem" />
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-column gap-2">
                    <h3 style="font-size: 1.3rem" class="mb-2 d-flex justify-content-between align-items-center">
                        Sign up/Login Banner image and content
                        <button
                            v-if="!signupBannerConfiguration.signup_banner_image"
                            type="button"
                            class="text-button btn-save p-2 d-flex gap-2 justify-content-center align-items-center"
                            :class="disableBtn ? 'btn-disabled' : ''"
                            @click="showSignupBannerConfiguration = true"
                            :disabled="disableBtn"
                        >
                            <img src="@/assets/px/drag-and-drop/add.svg" alt="" style="height: 20px" />
                            Add
                        </button>
                    </h3>
                    <span v-if="errors.signup_banner_image_content" class="text-danger">{{
                        errors.signup_banner_image_content
                    }}</span>
                    <div v-if="signupBannerConfiguration.signup_banner_image" class="d-flex flex-column p-2 gap-2">
                        <div
                            class="profile-function-card d-flex justify-content-between align-items-center px-5"
                            style="max-width: 100%"
                        >
                            <div class="d-flex justify-content-center align-items-center gap-4">
                                <img
                                    src="@/assets/px/mobex-health-plus-dashboard/image.svg"
                                    alt="Image"
                                    title="Image"
                                    height="30"
                                    width="40"
                                />
                                <ejs-tooltip
                                    target="#target"
                                    class="tooltipcontainer"
                                    cssClass="customtooltip"
                                    :content="signupBannerConfiguration.signup_banner_image_title"
                                >
                                    <span
                                        id="target"
                                        class="profile-function-card-label me-3 cursor-pointer profile-function-card-name w-100"
                                    >
                                        {{ signupBannerConfiguration.signup_banner_image_title }}
                                    </span>
                                </ejs-tooltip>
                            </div>
                            <div class="d-flex justify-content-center align-items-center gap-4 cursor-pointer">
                                <ejs-tooltip
                                    class="tooltipcontainer"
                                    content="Edit"
                                    target="#target"
                                    cssClass="customtooltip"
                                >
                                    <img
                                        src="@/assets/px/edit-icon.png"
                                        alt=""
                                        style="height: 20px"
                                        id="target"
                                        :class="disableBtn ? 'btn-disabled' : 'cursor-pointer'"
                                        :disabled="disableBtn"
                                        @click="showSignupBannerConfiguration = true"
                                    />
                                </ejs-tooltip>
                            </div>
                        </div>
                    </div>
                    <div
                        v-else
                        class="font-16 text-bolder d-flex align-items-center justify-content-center"
                        style="min-height: 6rem"
                    >
                        No data Avaialable
                    </div>
                </div>

               <!-- Registration Toggle -->
<div class="mt-4 p-3">
    <h3 class="section-label mb-2">Registration</h3>
    <SegmentedButtonPair
        :value="signup_enabled === 1"
        :options="enabledDisabledOptions"
        :disabled="disableBtn"
        @input="handleSignupToggle"
    />
</div>

<!-- Registration ID Dropdown -->
<div v-if="signup_enabled === 1" class="d-flex flex-column mt-4 p-3">
    <h3 style="font-size: 1.3rem" class="mb-2">Registration Form</h3>
    <div style="max-width: 300px">
        <Multiselect
            id="registration"
            track-by="id"
            label="name"
            placeholder="Select Registration"
            v-model="selectedRegistration"
            @input="onRegistrationChange"
            :options="registrationList"
            :searchable="true"
            :allow-empty="false"
            :show-labels="false"
            :disabled="disableBtn"
        />
    </div>
</div>

<!-- Registration Approval Workflow Toggle -->
<div v-if="signup_enabled === 1" class="mt-2 p-3">
    <h3 class="section-label mb-2">Registration Approval Workflow</h3>
    <SegmentedButtonPair
        :value="registration_approval_enabled === 1"
        :options="enabledDisabledOptions"
        :disabled="disableBtn"
        @input="handleRegistrationApprovalToggle"
    />
</div>

<!-- Medicaid ID Format -->
<div class="mt-2 p-3">
    <MedicaidIdFormatSelector
        :value="medicaid_state"
        :disabled="disableBtn"
        @input="handleMedicaidFormatChange"
    />
</div>
            </div>
        </div>

        <!-- Modals -->
        <EditIntroSlideModal
            v-if="showIntroSlidesEditModal"
            :applicationId="applicationId"
            @save="handleIntroSlide"
            @cancel="showIntroSlidesEditModal = false"
        />

        <EditSignupBannerConfiguration
            v-if="showSignupBannerConfiguration"
            :applicationId="applicationId"
            :profileFunction="signupBannerConfiguration"
            @save="handleSignupBannerConfiguration"
            @cancel="showSignupBannerConfiguration = false"
        />
    </div>
</template>

<script>
    import SpinLoader from '@/components/general/loading/SpinLoader.vue';
    import IntroSlideCard from '@/components/company/member-profiles/IntroSlideCard.vue';
    import EditIntroSlideModal from '@/components/company/member-profiles/EditIntroSlideModal.vue';
    import EditSignupBannerConfiguration from '@/components/company/member-profiles/EditSignupBannerConfiguration.vue';
    import SegmentedButtonPair from '@/components/general/inputs/SegmentedButtonPair.vue';
    import MedicaidIdFormatSelector from '@/components/application_builder/MedicaidIdFormatSelector.vue';
    import Multiselect from 'vue-multiselect';
    import { dashboardBuilder, upload, registrationConfig } from '@/util/apiRequests';

    export default {
        name: 'ApplicationConfiguration',
        components: {
            SpinLoader,
            IntroSlideCard,
            EditIntroSlideModal,
            EditSignupBannerConfiguration,
            SegmentedButtonPair,
            MedicaidIdFormatSelector,
            Multiselect,
        },
        props: {
            applicationId: {
                type: Number,
            },
            applicationData: {
                type: Object,
            },
            introSlides: {
                type: Array,
            },
            errors: {
                type: Object,
            },
        },
        data() {
            return {
                introSlideList: [],
                deletedSlideIds: [],
                app_startup_logo: null,
                app_startup_screen_background: null,
                waiting_animation: null,
                signup_logo: null,
                signup_banner_image: null,
                signup_banner_image_content: null,
                app_startup_logo_loading: false,
                signup_logo_loading: false,
                app_startup_screen_background_loading: false,
                waiting_animation_loading: false,
                app_startup_logo_err: null,
                app_startup_screen_background_err: null,
                waiting_animation_err: null,
                signup_logo_err: null,
                showIntroSlidesEditModal: false,
                showSignupBannerConfiguration: false,
                signupBannerConfiguration: {
                    signup_banner_image: null,
                    signup_banner_image_title: null,
                    signup_banner_image_content: null,
                },
                signup_enabled: true, // Sign Up Toggle state
                registration_approval_enabled: 0,
                medicaid_state: null,
                selectedRegistration: null,
                registrationList: [],
                enabledDisabledOptions: [
                    { label: 'Enabled', value: true },
                    { label: 'Disabled', value: false },
                ],
            };
        },
        computed: {
            disableBtn() {
                return (
                    this.app_startup_logo_loading ||
                    this.app_startup_screen_background_loading ||
                    this.signup_logo_loading ||
                    this.waiting_animation_loading
                );
            },
            disableActiveIntroSlides() {
                const activeSlides = this.introSlideList.filter((slide) => slide.is_active);
                return activeSlides?.length >= 3;
            },
        },
        methods: {
            handleValues(type, value) {
                this.errors[type] = null;
                this.$emit('captureValues', { applicationData: { [type]: value } });
            },
            async geturl(fileId) {
                const endpoint = upload.getUrl();
                const response = await this.$api.post(endpoint, { fileId });
                if (!response.data.success) {
                    throw response.data.error;
                }
                return response.data.url;
            },
            async uploadImage(event) {
                const file = event.target.files[0];
                if (!file) return;

                const fileExtension = file.name.split('.').pop().toLowerCase();
                const allowedExtensions = ['png', 'jpg', 'jpeg', 'webp'];
                const type = event.target.name;

                let err = 0,
                    errMsg;

                if (type == 'waiting_animation' && fileExtension !== 'gif') {
                    err++;
                    errMsg = 'Only GIF files are allowed for Waiting Animation';
                } else if (type !== 'waiting_animation' && !allowedExtensions.includes(fileExtension)) {
                    err++;
                    errMsg = 'Only PNG, JPG, JPEG, and WEBP files are allowed';
                }

                if (file.size / 1024 / 1024 > 10) {
                    err++;
                    errMsg = 'Size should not be greater than 10MB';
                }

                if (err) {
                    if (type === 'app_startup_logo') {
                        this.app_startup_logo_err = errMsg;
                    } else if (type === 'app_startup_screen_background') {
                        this.app_startup_screen_background_err = errMsg;
                    } else if (type === 'startup_logo') {
                        this.signup_logo_err = errMsg;
                    } else if (type === 'waiting_animation') {
                        this.waiting_animation_err = errMsg;
                    }
                    this.$toasted.error(errMsg);
                    return;
                }

                this.$emit('handlePageChangeDisabled', true);

                if (type == 'app_startup_logo') {
                    this.app_startup_logo_loading = true;
                    this.app_startup_logo_err = null;
                } else if (type == 'app_startup_screen_background') {
                    this.app_startup_screen_background_loading = true;
                    this.app_startup_screen_background_err = null;
                } else if (type == 'signup_logo') {
                    this.signup_logo_loading = true;
                    this.signup_logo_err = null;
                } else if (type == 'waiting_animation') {
                    this.waiting_animation_loading = true;
                    this.waiting_animation_err = null;
                }

                var reader = new FileReader();
                reader.readAsDataURL(file);
                let that = this;

                reader.onload = async function () {
                    const img = new Image();
                    img.src = reader.result;

                    img.onload = async function () {
                        let formData = new FormData();
                        formData.append('file', file);
                        formData.append('type', type);

                        const endpoint = dashboardBuilder.uploadImageAssets(that.applicationId, type, 0, 'public');
                        let response = await that.$api.post(endpoint, formData);

                        if (!response.data.success) {
                            throw response.data.error;
                        }

                        if (type == 'app_startup_logo') {
                            that.app_startup_logo = await that.geturl(response.data.s3_link);
                            that.app_startup_logo_loading = false;
                        } else if (type == 'app_startup_screen_background') {
                            that.app_startup_screen_background = await that.geturl(response.data.s3_link);
                            that.app_startup_screen_background_loading = false;
                        } else if (type == 'signup_logo') {
                            that.signup_logo = await that.geturl(response.data.s3_link);
                            that.signup_logo_loading = false;
                        } else if (type == 'waiting_animation') {
                            that.waiting_animation = await that.geturl(response.data.s3_link);
                            that.waiting_animation_loading = false;
                        }
                        that.$emit('handlePageChangeDisabled', false);
                        that.handleValues(type, response.data.s3_link);
                    };
                };
                reader.onerror = function (error) {
                    if (type == 'app_startup_logo') {
                        that.app_startup_logo_loading = false;
                        that.app_startup_logo_err = error;
                    } else if (type == 'app_startup_screen_background') {
                        that.app_startup_screen_background_loading = false;
                        that.app_startup_screen_background_err = error;
                    } else if (type == 'signup_logo') {
                        that.signup_logo_loading = false;
                        that.signup_logo_err = error;
                    } else if (type == 'waiting_animation') {
                        that.waiting_animation_loading = false;
                        that.waiting_animation_err = error;
                    }
                    that.$emit('handlePageChangeDisabled', false);
                    that.$toasted.error('Failed to upload image', error);
                };
            },
            handleIntroSlide(data) {
                if (data.id) {
                    this.introSlideList = this.introSlideList.map((el) => {
                        if (data.id === el.id) {
                            data.isUpdated = true;
                            data.isUpdated = !data.isCreated ? true : false;
                            data.description = data.description.trim();
                            return data;
                        }
                        return el;
                    });
                } else {
                    const activeSlides = this.introSlideList.filter((slide) => slide.is_active);
                    const newSlide = {
                        ...data,
                        description: data.description.trim(),
                        id: this.introSlideList.length + 1,
                        isCreated: true,
                        is_active: activeSlides.length < 3,
                    };
                    this.introSlideList.push(newSlide);
                }

                this.showIntroSlidesEditModal = false;
                this.handleValues('introSlideList', this.introSlideList);
            },
            introSlideToggle(event) {
                this.introSlideList = this.introSlideList.map((el) => {
                    if (event.profileFunction.id === el.id) {
                        el.is_active = event.value ? true : false;
                        el.isUpdated = !el.isCreated ? true : false;
                    }
                    return el;
                });

                this.handleValues('introSlideList', this.introSlideList);
            },
            handleDeleteIntroSlide(data) {
                this.introSlideList = this.introSlideList.filter((el) => data.id !== el.id);
                if (!data.isCreated) {
                    this.deletedSlideIds.push(data.id);
                }

                this.handleValues('introSlideList', this.introSlideList);
                this.$emit('captureValues', {
                    applicationData: { deletedSlideIds: this.deletedSlideIds },
                });
            },
            handleSignupBannerConfiguration(data) {
                this.signupBannerConfiguration = {
                    signup_banner_image: data.signup_banner_image,
                    signup_banner_image_title: data.signup_banner_image_title.trim(),
                    signup_banner_image_content: data.signup_banner_image_content.trim(),
                };
                this.showSignupBannerConfiguration = false;
                this.errors.signup_banner_image_content = null;
                this.$emit('captureValues', { applicationData: { ...data } });
            },
            handleSignupToggle(value) {
                this.errors.signup_enabled = null;
                const newValue = value ? 1 : 0;
                this.signup_enabled = newValue;
                this.$emit('captureValues', {
                    applicationData: { signup_enabled: newValue },
                });
            },
            handleRegistrationApprovalToggle(value) {
                const newValue = value ? 1 : 0;
                this.registration_approval_enabled = newValue;
                this.$emit('captureValues', {
                    applicationData: { registration_approval_enabled: newValue },
                });
            },
            handleMedicaidFormatChange(value) {
                this.medicaid_state = value;
                this.$emit('captureValues', {
                    applicationData: { medicaid_state: value },
                });
            },
            async fetchRegistrations() {
                try {
                    const endpoint = registrationConfig.getAll();
                    const response = await this.$api.get(endpoint);
                    if (response?.data?.data) {
                        this.registrationList = response.data.data;
                    } else if (Array.isArray(response?.data)) {
                        this.registrationList = response.data;
                    }
                } catch (error) {
                    console.error('Failed to fetch registrations:', error);
                }
            },
            onRegistrationChange(selected) {
                this.$emit('captureValues', {
                    applicationData: { registration_id: selected ? selected.id : null },
                });
            },
        },
        async created() {
            window.scrollTo(0, 0);

            const {
                app_startup_logo,
                app_startup_screen_background,
                signup_logo,
                signup_banner_image,
                signup_banner_image_title,
                signup_banner_image_content,
                waiting_animation,
            } = this.applicationData;

            if (app_startup_logo) {
                this.app_startup_logo = await this.geturl(app_startup_logo);
            }

            if (app_startup_screen_background) {
                this.app_startup_screen_background = await this.geturl(app_startup_screen_background);
            }

            if (signup_logo) {
                this.signup_logo = await this.geturl(signup_logo);
            }

            if (signup_banner_image && signup_banner_image_title && signup_banner_image_content) {
                this.signupBannerConfiguration = {
                    signup_banner_image,
                    signup_banner_image_title,
                    signup_banner_image_content,
                };
            }

            if (this.introSlides.length) {
                this.introSlideList = [...this.introSlides];
            }

            if (waiting_animation) {
                this.waiting_animation = await this.geturl(waiting_animation);
            }

            // Initialize signup toggle from existing data
            if (this.applicationData.signup_enabled !== undefined) {
                this.signup_enabled = this.applicationData.signup_enabled ? 1 : 0;
            }

            // Initialize registration approval workflow
            if (this.applicationData.registration_approval_enabled !== undefined) {
                this.registration_approval_enabled = this.applicationData.registration_approval_enabled ? 1 : 0;
            }

            // Initialize medicaid state
            if (this.applicationData.medicaid_state !== undefined) {
                this.medicaid_state = this.applicationData.medicaid_state;
            }

            // Fetch registrations and pre-select if saved
            await this.fetchRegistrations();
            if (this.applicationData.registration_id) {
                this.selectedRegistration = this.registrationList.find(
                    (reg) => reg.id === this.applicationData.registration_id
                ) || null;
            }

        },
    };
</script>

<style scoped>
    .add-btn {
        width: 15rem;
        height: 6rem;
        color: #5155c3;
        border: 2px solid #5155c3;
        border-radius: 15px;
        background-color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 1rem;
        font-size: 1.2rem;
        font-weight: 600;
    }

    .btn-save {
        border-radius: 10px;
        font-weight: 600;
        width: 8rem;
        background: transparent;
        color: #5155c3;
        border: 2px solid #5155c3;
    }

    .profile-function-card-name {
        font-family: Roboto;
        font-size: 16px;
        font-weight: 500;
        color: #373cbb;
        text-transform: capitalize;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
        max-width: 65rem;
    }

    .upload-section {
        border-radius: 10px;
        border: 2px solid #d7d7d7;
        background: #fff;
        box-shadow: 0px 20px 5px 0px rgba(0, 0, 0, 0.03);
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .upload-section-title {
        font-size: 1rem;
        margin-left: 1rem;
        color: #7c7979;
        font-weight: 600;
    }

    .upload-btn {
        border-radius: 6px;
        background: #5155c3;
        color: #fff;
        font-family: 'Roboto';
        box-shadow: 0px 20px 5px 0px rgba(0, 0, 0, 0.03);
    }

    .btn-disabled {
        cursor: not-allowed;
        opacity: 0.8;
    }

    .section-label {
        font-size: 1.3rem;
        font-weight: 600;
        color: #5155c3;
    }

    /* Sign Up Toggle Styles - Matching Dashboard Builder Style */
    .toggle-switch .switch {
        position: relative;
        display: inline-block;
        width: 40px;
        height: 18px;
        margin-right: 7px;
    }

    .toggle-switch .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .toggle-switch .switch input:checked + .slider {
        background-color: #5057C3 !important;
        background-color: var(--button-color);
        box-shadow: 0 0 0 2px rgba(0, 0, 0, 0);
        transition: 0.2s;
    }

    .toggle-switch .switch .slider {
        height: 20px;
        cursor: pointer;
        position: absolute;
        top: 0;
        left: 0;
        right: 2px;
        bottom: 0;
        box-shadow: inset 0 0 0 1px #B1D0FF;
        border-radius: 3em;
        transition: 0.2s;
        background: #B1D0FF;
    }

    .toggle-switch .switch .slider:before {
        content: "";
        height: 16px;
        width: 16px;
        background: white;
        border-radius: 3em;
        position: absolute;
        left: 2px;
        top: 50%;
        transform: translate(0px, -50%);
        transition: 0.2s;
    }

    .toggle-switch .switch input:checked + .slider:before {
        -webkit-transform: translate(18px, -50%);
        -ms-transform: translate(18px, -50%);
        transform: translate(18px, -50%);
        background: white;
        transition: 0.2s;
    }

    .toggle-switch .switch input:focus + .slider {
        box-shadow: 0 0 0 2px rgba(80, 87, 195, 0.25);
    }

    .font-14 {
        font-size: 0.875rem;
    }
</style>